import { render, staticRenderFns } from "./TaskPDF.vue?vue&type=template&id=59fe27ec"
import script from "./TaskPDF.vue?vue&type=script&lang=js"
export * from "./TaskPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports